import {PageSubContainerSkeleton, ToolbarSkeleton} from "@project/components/feedback";
import {Skeleton} from "@project/design-system-web";

export function MaterialDescriptionsPending() {
  return (
    <PageSubContainerSkeleton>
      <ToolbarSkeleton>
        <div className="flex-1" />
        <ToolbarSkeleton.Actions>
          <ToolbarSkeleton.Button />
        </ToolbarSkeleton.Actions>
      </ToolbarSkeleton>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({length: 3}).map((_, index) => (
          <Skeleton className="h-40 w-full rounded-xl" key={index} />
        ))}
      </div>
    </PageSubContainerSkeleton>
  );
}
